import posthog from "posthog-js";

function initializePostHog(): void {
  const apiKey = process.env.REACT_APP_POSTHOG_KEY;
  const apiHost = process.env.REACT_APP_POSTHOG_HOST;
  if (!apiKey || !apiHost) {
    return;
  }
  posthog.init(apiKey, {
    api_host: apiHost || "https://app.posthog.com",
    person_profiles: "identified_only",
    capture_pageview: true,
    autocapture: true,
  });
}

export function trackEvent(
  eventName: string,
  properties?: Record<string, any>,
  userId?: string
): void {
  try {
    if (userId) {
      posthog.identify(userId);
    }

    posthog.capture(eventName, {
      timestamp: new Date().toISOString(),
      ...properties,
    });
  } catch (error) {
    console.warn("Failed to track event:", error);
  }
}

export const trackLogin = (userEmail: string, login_method: string) => {
  trackEvent("user_login", {
    user_id: userEmail,
    login_method: login_method,
  });
};

export const trackLogout = (userId?: number, userEmail?: string) => {
  trackEvent("user_logout", {
    user_id: userId,
    userEmail: userEmail,
  });
};

// Payment method mapping
const getPaymentMethodName = (methodId: number): string => {
  const paymentMethodMap: Record<number, string> = {
    0: "Check Capture",
    3: "ACH",
    4: "Wire",
  };
  return paymentMethodMap[methodId] || `Unknown (${methodId})`;
};

export const trackPaymentSubmission = (
  paymentId: number,
  amount: number,
  paymentMethod: number
) => {
  trackEvent("payment_submitted", {
    payment_id: paymentId,
    amount,
    payment_method: paymentMethod,
    payment_method_name: getPaymentMethodName(paymentMethod),
  });
};

export const trackPageView = (pageName: string) => {
  trackEvent("page_viewed", {
    page_name: pageName,
    url: window.location.href,
  });
};

export const trackError = (errorMessage: string, errorCode?: string) => {
  trackEvent("error_occurred", {
    error_message: errorMessage,
    error_code: errorCode,
    url: window.location.href,
  });
};

export default initializePostHog;
